import React, { useCallback, useState } from 'react';
import styles from './styles.styl';
import cn from 'classnames/bind';
import { Text } from '@consta/uikit/Text';
import { Button } from '@consta/uikit/Button';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { clearTestData } from 'src/redux/features/surveys/testData/actions';
import { Action } from 'redux';
import { loadAddCreateSurveys } from 'src/redux/features/surveys/createSurveys/actions';
import { changeStatusSurveyIdle } from 'src/redux/features/surveys/changeSurveyStatus/actions';
import { addCreateSurveysPendingSelector } from 'src/redux/features/surveys/createSurveys/selectors';
import { oneSurveyIdle } from 'src/redux/features/surveys/oneSurvey/actions';
import { clearAllListQuestions } from 'src/redux/features/questions/allListQuestions/actions';
import { Modal } from '@consta/uikit/Modal';
import { ImportFileModal } from '../ImportFileModal';
import { loadImportSurveys } from 'src/redux/features/surveys/importSurveys/actions';
import { importSurveysPendingSelector } from 'src/redux/features/surveys/importSurveys/selectors';

const cx = cn.bind(styles);

export interface IDashboardHelloProps {
  clearTestData: () => void;
  changeStatusSurveyIdle: () => void;
  oneSurveyIdle: () => void;
  loadAddCreateSurveys: () => void;
  clearAllListQuestions: () => void;
  isAddPending: boolean;
  loadImportSurveys: (data: any) => void;
  isImportPending: boolean;
}

const DashboardHello: React.FC<IDashboardHelloProps> = ({
  clearTestData,
  changeStatusSurveyIdle,
  loadAddCreateSurveys,
  isAddPending,
  oneSurveyIdle,
  clearAllListQuestions,
  loadImportSurveys,
  isImportPending,
}) => {
  const handAdd = useCallback(() => {
    clearTestData();
    changeStatusSurveyIdle();
    oneSurveyIdle();
    clearAllListQuestions();
    loadAddCreateSurveys();
  }, [
    changeStatusSurveyIdle,
    clearAllListQuestions,
    clearTestData,
    loadAddCreateSurveys,
    oneSurveyIdle,
  ]);
  const [modalImportClose, setModalImportCLose] = useState(false);

  return (
    <div className={cx('DashboardHello')}>
      <div className={cx('DashboardHello__main')}>
        <Text size="xl" className={cx('DashboardHello__title')}>
          Приветствуем на сервисе опросов
        </Text>
        <Text size="s">
          В периметре компании происходит множество процессов, по которым
          необходимо получить обратную связь. Дать такую возможность
          предполагается при помощи разрабатываемого приложения. Оно позволит
          сотрудникам проходить тест перед экзаменом и заполнять опросные листы
          по качеству питания, процессу перевахтовки и т.п.
        </Text>
      </div>
      <div className={cx('DashboardHello__btns')}>
        <Button
          onClick={() => setModalImportCLose(true)}
          label="Создать опрос из excel"
        />
        <Button
          onClick={() => handAdd()}
          view="secondary"
          label="Создать опрос вручную"
          loading={isAddPending}
        />
      </div>
      <Modal isOpen={modalImportClose} hasOverlay>
        <ImportFileModal
          loadImportSurveys={loadImportSurveys}
          setModalImportCLose={setModalImportCLose}
          isImportPending={isImportPending}
        />
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: State) => ({
  isAddPending: addCreateSurveysPendingSelector(state),
  isImportPending: importSurveysPendingSelector(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<State, void, Action>) => ({
  clearTestData: () => dispatch(clearTestData()),
  changeStatusSurveyIdle: () => dispatch(changeStatusSurveyIdle()),
  loadAddCreateSurveys: () => dispatch(loadAddCreateSurveys()),
  oneSurveyIdle: () => dispatch(oneSurveyIdle()),
  clearAllListQuestions: () => dispatch(clearAllListQuestions()),
  loadImportSurveys: (data: any) => dispatch(loadImportSurveys(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardHello);
